export default {
    "Subtitles": "Subtitles",
    "Disabled": "Disabled",
    "af": "Afrikaans",
    "sq": "Albanian",
    "am": "Amharic",
    "ar": "Arabic",
    "hy": "Armenian",
    "as": "Assamese",
    "az": "Azerbaijani",
    "ba": "Bashkir",
    "eu": "Basque",
    "be": "Belarusian",
    "bn": "Bengali",
    "bs": "Bosnian",
    "br": "Breton",
    "bg": "Bulgarian",
    "ca": "Catalan",
    "zh": "Chinese",
    "hr": "Croatian",
    "cs": "Czech",
    "da": "Danish",
    "nl": "Dutch",
    "en": "English",
    "et": "Estonian",
    "fo": "Faroese",
    "fi": "Finnish",
    "fr": "French",
    "gl": "Galician",
    "ka": "Georgian",
    "de": "German",
    "el": "Greek",
    "gu": "Gujarati",
    "ht": "Haitian Creole",
    "ha": "Hausa",
    "haw": "Hawaiian",
    "he": "Hebrew",
    "hi": "Hindi",
    "hu": "Hungarian",
    "is": "Icelandic",
    "id": "Indonesian",
    "it": "Italian",
    "ja": "Japanese",
    "jw": "Javanese",
    "kn": "Kannada",
    "kk": "Kazakh",
    "km": "Khmer",
    "ko": "Korean",
    "lo": "Lao",
    "la": "Latin",
    "lv": "Latvian",
    "ln": "Lingala",
    "lt": "Lithuanian",
    "lb": "Luxembourgish",
    "mk": "Macedonian",
    "mg": "Malagasy",
    "ms": "Malay",
    "ml": "Malayalam",
    "mt": "Maltese",
    "mi": "Maori",
    "mr": "Marathi",
    "mn": "Mongolian",
    "my": "Myanmar",
    "ne": "Nepali",
    "no": "Norwegian",
    "nn": "Nynorsk",
    "oc": "Occitan",
    "ps": "Pashto",
    "fa": "Persian",
    "pl": "Polish",
    "pt": "Portuguese",
    "pa": "Punjabi",
    "ro": "Romanian",
    "ru": "Russian",
    "sa": "Sanskrit",
    "sr": "Serbian",
    "sn": "Shona",
    "sd": "Sindhi",
    "si": "Sinhala",
    "sk": "Slovak",
    "sl": "Slovenian",
    "so": "Somali",
    "es": "Spanish",
    "su": "Sundanese",
    "sw": "Swahili",
    "sv": "Swedish",
    "tl": "Tagalog",
    "tg": "Tajik",
    "ta": "Tamil",
    "tt": "Tatar",
    "te": "Telugu",
    "th": "Thai",
    "bo": "Tibetan",
    "tr": "Turkish",
    "tk": "Turkmen",
    "uk": "Ukrainian",
    "ur": "Urdu",
    "uz": "Uzbek",
    "vi": "Vietnamese",
    "cy": "Welsh",
    "wo": "Wolof",
    "yi": "Yiddish",
    "yo": "Yoruba",
    "ace": "Acehnese",
    "an": "Aragonese",
    "ay": "Aymara",
    "bho": "Bhojpuri",
    "yue": "Cantonese",
    "ceb": "Cebuano",
    "zh-hans": "Chinese (simplified)",
    "zh-hant": "Chinese (traditional)",
    "prs": "Dari",
    "en-gb": "English (British)",
    "en-us": "English (American)",
    "eo": "Esperanto",
    "fr-ca": "French (Canadian)",
    "fr-fr": "French (France)",
    "de-de": "German (Germany)",
    "de-ch": "German (Swiss)",
    "gn": "Guarani",
    "ig": "Igbo",
    "ga": "Irish",
    "jv": "Javanese",
    "pam": "Kapampangan",
    "gom": "Konkani",
    "ckb": "Kurdish (Sorani)",
    "kmr": "Kurdish (Kurmanji)",
    "ky": "Kyrgyz",
    "lmo": "Lombard",
    "mai": "Maithili",
    "nb": "Norwegian (bokmål)",
    "om": "Oromo",
    "pag": "Pangasinan",
    "pt-br": "Portuguese (Brazilian)",
    "pt-pt": "Portuguese (European)",
    "qu": "Quechua",
    "st": "Sesotho",
    "scn": "Sicilian",
    "es-419": "Spanish (Latin American)",
    "ts": "Tsonga",
    "tn": "Tswana",
    "xh": "Xhosa",
    "zu": "Zulu"
}
